@let offersValue = offers();

<div padding>
  @if (offersValue.length > 1) {
    <rt-evaluation-job-field
      [control]="quickEvaluationForm.controls.offerId"
      [offers]="offersValue"
      [hasBox]="false"
      [selectShadow]="true"
      [rtEvaluationFieldRef]="quickEvaluationForm.controls.offerId"
      margin-bottom-small
    />
  }
  <rt-evaluation-rating-field
    [control]="quickEvaluationForm.controls.score"
    [ratingScale]="ratingScale()"
    [showValidationErrors]="submissionAttempted()"
    [rtEvaluationFieldRef]="quickEvaluationForm.controls.score"
    margin-bottom-small
  />
  <rt-evaluation-comment-field
    [control]="quickEvaluationForm.controls.ratingNote"
    [jsonControl]="quickEvaluationForm.controls.ratingNoteJson"
    [rtEvaluationFieldRef]="quickEvaluationForm.controls.ratingNote"
  />
</div>
